import { Navigate, Route, Routes } from 'react-router-dom';
import AppsOverviewPage from './AppsOverviewPage';
import EcommerceRoutes from './ecommerce';
import ProjectManagementRoutes from './project-management';
import CRMRoutes from './crm';
import HRRoutes from './hr-portal';
import FileManagerRoutes from './file-manager';
import AnalyticsRoutes from './analytics';
import ChatRoutes from './chat';
import CalendarRoutes from './calendar';
import InvoicingRoutes from './invoicing';
import HelpdeskRoutes from './helpdesk';

export default function AppsRoutes() {
  return (
    <Routes>
      <Route index element={<AppsOverviewPage />} />

      {/* E-Commerce Dashboard */}
      <Route path="ecommerce/*" element={<EcommerceRoutes />} />

      {/* Project Management */}
      <Route path="project-management/*" element={<ProjectManagementRoutes />} />

      {/* CRM System */}
      <Route path="crm/*" element={<CRMRoutes />} />

      {/* HR Portal */}
      <Route path="hr-portal/*" element={<HRRoutes />} />

      {/* File Manager */}
      <Route path="file-manager/*" element={<FileManagerRoutes />} />

      {/* Analytics Dashboard */}
      <Route path="analytics/*" element={<AnalyticsRoutes />} />

      {/* Chat Application */}
      <Route path="chat/*" element={<ChatRoutes />} />

      {/* Calendar & Scheduling */}
      <Route path="calendar/*" element={<CalendarRoutes />} />

      {/* Invoice & Billing */}
      <Route path="invoicing/*" element={<InvoicingRoutes />} />

      {/* Helpdesk & Ticketing */}
      <Route path="helpdesk/*" element={<HelpdeskRoutes />} />

      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
